import { render, staticRenderFns } from "./FileScreen.vue?vue&type=template&id=43049e76&"
import script from "./FileScreen.vue?vue&type=script&lang=js&"
export * from "./FileScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports